
import { DownArrowIcon, UpArrowIcon, } from '../../../components/Icons';

const Change = ({ value, change }) => {
    const isPositive = change > 0;
    const isNegative = change < 0;
    const changeColor = isPositive ? 'text-green' : isNegative ? 'text-red' : 'text-blue';
    const ChangeIcon = isPositive ? UpArrowIcon : isNegative ? DownArrowIcon : null;

    return (
        <span className="flex gap-4 items-center text-blue">
            {(isPositive || isNegative) && (
                <span className={`flex items-baseline gap-1 ${changeColor}`}>
                    {ChangeIcon && <ChangeIcon />}
                    <span className="leading-none text-[16px]">{change}%</span>
                </span>
            )}
            <span className="text-[45px]">{value}</span>
        </span>
    );
};

export default Change;
